/* ------------------------- External Dependencies -------------------------- */
import { connect } from 'react-redux';
import Render from './render';
/* ---------------------------- Module Package ------------------------------ */
import { popoverClose } from 'store/departments/actions'

const mapDispatchToProps = (dispatch, props) => ({
  popoverClose: () => dispatch(popoverClose({payload:{delta: props.delta }}))
})

export default connect(null, mapDispatchToProps)(Render);



// WEBPACK FOOTER //
// ./src/interface/containers/popover/PopoverClose/index.js